import { ProclientCallEvaluationHelpStatus } from "hassibot/services_v2/call-evaluation/types";
import { FinancialHelp } from "hassibot/services_v2/dsit/types";
import { ProclientVebEvaluationHelpStatus } from "hassibot/services_v2/veb-evaluation/types";

export enum PeriodType {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}

export type HelpData<
  T extends ProclientVebEvaluationHelpStatus | ProclientCallEvaluationHelpStatus,
> = {
  careRate: string | null;
  helpStatus: T | null;
  financialHelp: FinancialHelp | null;
  maxHoursPerMonth: string;
  department: string | null;
};
